export const CREATE_ROLE = 'role@create-role';
export const UPDATE_ROLE = 'role@update-role';
export const DELETE_ROLE = 'role@delete-role';
export const GET_PERMISSION = 'role@get-all-premission';
export const MANAGE_ROLE = 'role@manage-role';
export const GET_USERS_WITH_ROLES = 'role@get-users-with-roles';
